import {DatePipe} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';

import {
    AcabimSite,
    ColumnFilter,
    DataTableColumnData,
    DatatableComponent,
    DataTableConfig,
    DataTableDataSource,
    DataTableLazyLoadDataSource,
    DataTableLazyLoadRefresher,
    DataTableObservableCompletionListener,
    DataTableObservableErrorListener,
    GenericPayloadModel,
    GenericPayloadType,
    PaginatedRequest,
    PaginatedResponse,
    SiteApiService,
    TableAction
} from '@cas-hub/acabim-common-client';

import {map, tap} from 'rxjs/operators';

@Component({
    selector: 'acabim-admin-archived-sites',
    templateUrl: './archived-sites.component.html',
    styleUrls: ['./archived-sites.component.scss']
})
export class ArchivedSitesComponent implements OnInit {
    actionTitle = '  ';
    displayDataModal = false;
    displayWarningModal = false;
    siteData: GenericPayloadModel[] = [];
    dataTypes = GenericPayloadType;
    public archivedSites: AcabimSite[] = [];
    @ViewChild('archivedSiteDatatable') public dataTable!: DatatableComponent;
    isLoading = false;
    errorMessage: GenericPayloadModel[] = [];

    constructor(private readonly siteApiService: SiteApiService,
                protected readonly datePipe: DatePipe) {
    }

    public archivedSiteDataSources: DataTableDataSource<any>[] = [];

    public ngOnInit(): void {
        this.archivedSiteDataSources.push(
            // @ts-ignore
            new ArchivedSiteDataSources((first, length, sortOrder, sortField, filters) => {
                    const paginatedRequest = PaginatedRequest.FromDatatableRefresher(first, length, sortOrder, sortField);
                    // @ts-ignore
                    return this.siteApiService.getArchivedSites(paginatedRequest)
                        .pipe(map(data => data as PaginatedResponse<AcabimSite>), map(data => ({
                            totalRecords: data.totalRecords,
                            data: data.data
                        })), tap(data => {
                            data.data.forEach(project => {
                                project.lastModifiedDate = this.getDate(project.lastModifiedDate);
                            });
                        }));
                },
                (tableName: string, error: Error) => {
                    console.log('Error in retrieving data in table ', tableName);
                },
                (tableName: string) => {
                    console.log('completion');
                }, (action: TableAction) => {
                    if (action.id === 0) {
                        this.actionTitle = 'Reactivate';
                        this.onSiteAction();
                    } else if (action.id === 1) {
                        this.actionTitle = 'Delete';
                        this.onSiteAction();
                    }
                }
            )
        );
    }

    getDate(date: string): string {
        const newDate = new Date(date);
        return (this.datePipe.transform(newDate, 'dd MMM yyyy') as string);
    }

    private onSiteAction() {
        if (this.archivedSiteDataSources[0].selectedData.length < 1) {
            return;
        }
        this.archivedSiteDataSources[0].selectedData.forEach(site => {
            this.siteData.push({key: site.id, label: site.name, value: site.id, type: GenericPayloadType.text});
            this.displayDataModal = true;
        });
    }


    closeErrorDialog() {
        this.displayWarningModal = false;

    }


    public siteAction(action: boolean) {

        if (action) {
            this.isLoading = true;
            if (this.actionTitle === 'Reactivate') {
                this.archivedSiteDataSources[0].selectedData.forEach(site => {
                    this.siteApiService.unarchiveSite(site.id).subscribe(data => {
                        this.isLoading = false;
                        this.displayDataModal = false;
                        this.siteData = [];
                        this.archivedSiteDataSources[0].selectedData = [];
                        this.dataTable?.requestImmediateDataRefresh();
                    }, error => {
                        this.isLoading = false;
                        this.displayDataModal = false;
                        this.displayWarningModal = true;
                        Object.keys(JSON.parse(JSON.stringify(error)).error).forEach(key => {
                            this.errorMessage.push({key: key, type: GenericPayloadType.text, label: key, value: JSON.parse(JSON.stringify(error)).error[key]});
                        });
                    });
                });
            } else if (this.actionTitle === 'Delete') {
                this.archivedSiteDataSources[0].selectedData.forEach(site => {
                    this.siteApiService.deleteSite(site.id).subscribe(data => {
                        this.isLoading = false;
                        this.siteData = [];
                        this.archivedSiteDataSources[0].selectedData = [];
                        this.displayDataModal = false;
                        this.dataTable?.requestImmediateDataRefresh();
                    }, error => {
                        this.isLoading = false;
                        this.displayDataModal = false;
                        this.displayWarningModal = true;
                        Object.keys(JSON.parse(JSON.stringify(error)).error).forEach(key => {
                            this.errorMessage.push({key: key, type: GenericPayloadType.text, label: key, value: JSON.parse(JSON.stringify(error)).error[key]});
                        });
                    });
                });
            }

        } else {

            this.siteData = [];
            this.displayDataModal = false;

        }
    }

    setModal(value: boolean): void {
        this.displayDataModal = value;
        if (!value) {
            this.archivedSiteDataSources[0].selectedData = [];
            this.siteData = [];
        }
    }
}

export class ArchivedSiteDataSources extends DataTableLazyLoadDataSource<AcabimSite> {


    readonly columnData: DataTableColumnData[] =
        [
            {displayName: 'Name', objectPropertyName: 'name'},
            {displayName: 'Description', objectPropertyName: 'description'},
            {displayName: 'Last Modified', objectPropertyName: 'lastModifiedDate'}
        ];
    readonly config: DataTableConfig = {
        tableHeading: '',
        isSearchEnabled: true,
        searchPlaceHolder: '',
        emptyMessage: '',
        globalFilterFields: [],
        hasCheckbox: true,
        hasDetailsButton: false,
        isLazyLoadingEnabled: true,
        isPaginationEnabled: true,
        hasFilters: true,
        isExportEnabled: false,
        hasActions: true
    };
    readonly columnFilters: ColumnFilter[] = [];
    readonly actions: TableAction[] = [{name: 'Reactivate', id: 0}, {name: 'Delete', id: 1}];

    onDataExpanded(value: AcabimSite): void {
    }

    constructor(readonly refresher: DataTableLazyLoadRefresher<AcabimSite>,
                readonly observableErrorListener?: DataTableObservableErrorListener,
                readonly observableCompleteListener?: DataTableObservableCompletionListener,
                readonly actionListener?: (action: TableAction) => void) {
        super(refresher, observableErrorListener, observableCompleteListener);
    }

    onAction(action: TableAction): void {
        if (this.actionListener) {
            this.actionListener(action);
        }
    }
}
